import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSectionHeader from '@/views/my-projects/components/MyProjectsSectionHeader.vue';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import BCXPaginationSwitcher from '@/components/molecules/BCXPaginationSwitcher.vue';
import {
  computed, onBeforeUnmount, onMounted,
} from 'vue';
import ProjectListItem from '@/views/project-forum/components/ProjectListItem.vue';
import MyProjectsOfferDetail from '@/views/my-projects/components/offer-details/MyProjectsOfferDetail.vue';
import {
  asyncComputed, useLocalStorage, useNow, useSessionStorage
} from '@vueuse/core';
import convertProjectToProjectListItemProject from '@/utils/convertProjectToProjectListItemProject';
import ProjectListItemSkeleton from '@/views/project-forum/components/ProjectListItemSkeleton.vue';
import { useRouter } from 'vue2-helpers/vue-router';
import { getRouteForProjectId } from '@/views/my-projects/utils/utils';
import MyProjectsOffersTable from '@/views/my-projects/components/offers/MyProjectsOffersTable.vue';
import useBcxTableSearchFilterSort from '@/mixins/useBcxTableSearchFilterSort';
import { filter as overviewFilter, projectSortFieldValue, searchCallback } from '@/views/my-projects/components/overview/searchFilterSortFunctions';
import MarvinInfoBox from '@/views/recommendations/components/MarvinInfoBox.vue';
import useUser from '@/mixins/useUser';
import Close from '@/components/svg-components/X.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsReceivedOffers',
  setup(__props) {

const {
  selectedProjectWithOffers, receivedProjectsWithOffers, visibleReceivedProjectsWithOffers, isNarrow, isStatusLayerOpen, offers, loadProject,
  statusLayerProject, projectIdsToKeepInProjectFilter
} = useMyProjects();

const router = useRouter();

const { tUserFallback: t } = useUser('self');

const selectedProjectPosition = computed(() => visibleReceivedProjectsWithOffers.value.findIndex((project) => project.id === selectedProjectWithOffers.value?.id));

const setProjectFromPosition = (diff: number) => {
  let newPos = selectedProjectPosition.value + diff;
  if (newPos < 0) newPos = visibleReceivedProjectsWithOffers.value.length - 1;
  else if (newPos >= visibleReceivedProjectsWithOffers.value.length) newPos = 0;
  router.push(getRouteForProjectId(visibleReceivedProjectsWithOffers.value[newPos].id));
};

const nextProject = () => {
  setProjectFromPosition(1);
};

const prevProject = () => {
  setProjectFromPosition(-1);
};

const fullProject = asyncComputed(async () => {
  const projectId = selectedProjectWithOffers.value?.project.id;
  if (!projectId) return null;
  const project = await loadProject(projectId);
  if (!project) return null;
  return project;
}, null);

const projectListItem = computed(() => (fullProject.value ? convertProjectToProjectListItemProject(fullProject.value) : null), null);

const openStatusLayer = () => {
  isStatusLayerOpen.value = true;
  statusLayerProject.value = fullProject.value;
};

// when project status changes, we still want to keep it in the list while we're in it:
onMounted(() => {
  projectIdsToKeepInProjectFilter.value = visibleReceivedProjectsWithOffers.value.map((project) => project.project.id);
});
onBeforeUnmount(() => {
  projectIdsToKeepInProjectFilter.value = [];
});

if (!visibleReceivedProjectsWithOffers.value.length) {
  const { finalRows } = useBcxTableSearchFilterSort({
    searchCallback,
    filter: overviewFilter,
    sortValueCallback: projectSortFieldValue,

    states: useLocalStorage('projects-overview-tablefilter', []).value,
    sortField: useLocalStorage('projects-overview-tablesearch', '').value,
    isAscending: useLocalStorage('projects-overview-tabledir', false).value,
    searchTerm: useLocalStorage('projects-overview-tablesearch', '').value,
  }, receivedProjectsWithOffers);

  visibleReceivedProjectsWithOffers.value = finalRows.value;
}

const noRemainingOffers = computed(() => ((fullProject.value?.offersInfo.remainingOffers ?? 1) <= 0));
const hiddenMaxOffersBannerForProject = useSessionStorage<any>('hiddenMaxOffersBannerForProject', {});
const now = useNow();
const isInfoBannerVisible = computed(() => {
  if (!fullProject.value) return false;
  const lastHidden = hiddenMaxOffersBannerForProject.value[fullProject.value.id];
  return noRemainingOffers.value && (now.value.getTime() - (lastHidden ?? 0) > (1000 * 60 * 60 * 24));
});

const closeInfoBanner = () => {
  if (fullProject.value) {
    hiddenMaxOffersBannerForProject.value = { ...hiddenMaxOffersBannerForProject.value, ...{ [fullProject.value.id]: now.value.getTime() } };
  }
};

return { __sfc: true,selectedProjectWithOffers, receivedProjectsWithOffers, visibleReceivedProjectsWithOffers, isNarrow, isStatusLayerOpen, offers, loadProject, statusLayerProject, projectIdsToKeepInProjectFilter, router, t, selectedProjectPosition, setProjectFromPosition, nextProject, prevProject, fullProject, projectListItem, openStatusLayer, noRemainingOffers, hiddenMaxOffersBannerForProject, now, isInfoBannerVisible, closeInfoBanner, MyProjectsSectionHeader, BCXPaginationSwitcher, ProjectListItem, MyProjectsOfferDetail, ProjectListItemSkeleton, MyProjectsOffersTable, MarvinInfoBox, Close }
}

})